var plugin_rtlignore_default = {
  "alignLeft": "q6tYB",
  "textWrapNowrap": "_2PDPg",
  "alignRight": "ecsvo",
  "alignCenter": "-jqB-",
  "sizeFullWidth": "hTxPH",
  "renderedInTable": "o96x2",
  "sizeOriginal": "BYy9j",
  "sizeContent": "l-L-2",
  "sizeSmall": "RUC5E",
  "sizeSmallCenter": "-wwPM",
  "flex": "_1RGk2",
  "atomic": "fxo01",
  "embed": "_0-mYv",
  "horizontalScrollbar": "u1NZW",
  "pluginContainerMobile": "_-0bhP"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
